import React from "react";
import { Avatar, Box, Button, Chip, Stack, Typography } from "@mui/material";
import { saasDirectoryRowSx } from "./saasStyles";

export default function DirectoryRowCard({
  selected = false,
  avatarText,
  title,
  subtitle,
  chips = [],
  columns = [],
  actionLabel = "Select",
  onSelect,
}) {
  return (
    <Box
      sx={{
        ...saasDirectoryRowSx,
        borderColor: selected ? "#bcc9ff" : "#dfe6f4",
        borderRadius: "999px",
        boxShadow: "none",
        p: { xs: 1.5, md: 1.8 },
      }}
    >
      <Stack direction={{ xs: "column", xl: "row" }} spacing={2.5} alignItems={{ xs: "flex-start", xl: "center" }}>
        <Stack direction="row" spacing={1.5} alignItems="center" sx={{ flex: 1.25, minWidth: 0 }}>
          <Box
            sx={{
              width: 19,
              height: 19,
              borderRadius: "50%",
              border: selected ? "2px solid #5f6fff" : "2px solid #8e9ab2",
              display: "grid",
              placeItems: "center",
              flexShrink: 0,
            }}
          >
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                bgcolor: selected ? "#5f6fff" : "transparent",
              }}
            />
          </Box>

          <Avatar
            sx={{
              width: 48,
              height: 48,
              background: "linear-gradient(180deg, rgba(184,232,255,0.95) 0%, rgba(223,234,255,0.92) 100%)",
              color: "#5871ff",
              fontWeight: 800,
              border: "1px solid #d7e4f2",
              boxShadow: "none",
            }}
          >
            {avatarText}
          </Avatar>

          <Box sx={{ minWidth: 0 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 800, lineHeight: 1.15 }}>
              {title}
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.35, mb: 0.8 }}>
              {subtitle}
            </Typography>
            <Stack direction="row" spacing={0.75} useFlexGap flexWrap="wrap">
              {chips.map((chip) => (
                <Chip
                  key={`${title}-${chip.label}`}
                  label={chip.label}
                  size="small"
                  sx={{
                    height: 24,
                    borderRadius: 999,
                    fontSize: 12,
                    fontWeight: 700,
                    bgcolor: chip.color === "success" ? "#effaf4" : "#f4f7ff",
                    color: chip.color === "success" ? "#1dbf73" : "#5a68ff",
                    border: "none",
                  }}
                />
              ))}
            </Stack>
          </Box>
        </Stack>

        <Stack direction={{ xs: "column", md: "row" }} spacing={{ xs: 1.5, md: 3.5 }} sx={{ flex: 1, width: "100%" }}>
          {columns.map((column) => (
            <Box key={`${title}-${column.label}`} sx={{ minWidth: { xs: "auto", md: 170 }, flex: 1 }}>
              <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 0.45 }}>
                {column.label}
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: 800, color: "#25324b" }}>
                {column.value}
              </Typography>
              {column.secondary ? (
                <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.45 }}>
                  {column.secondary}
                </Typography>
              ) : null}
            </Box>
          ))}
        </Stack>

        <Button
          variant="outlined"
          onClick={onSelect}
          sx={{
            minWidth: 102,
            height: 40,
            borderRadius: "12px",
            borderColor: "#b8c5ff",
            color: "#5867ff",
            bgcolor: "#fff",
            flexShrink: 0,
          }}
        >
          {actionLabel}
        </Button>
      </Stack>
    </Box>
  );
}
